var map = {
	"./android-qr.png": "7a94",
	"./app-store.png": "89a7",
	"./appstore.png": "3594",
	"./download-tps-banner.png": "4ad2",
	"./false_qr.png": "05f1",
	"./googleplay.png": "684f",
	"./health-guide-affony.png": "0c3f",
	"./health-guide-back.png": "1134",
	"./health-guide-cancer-mama.png": "71eb",
	"./health-guide-driving.png": "ef6f",
	"./health-guide-fitosanitaries.png": "6e2d",
	"./health-guide-food.png": "36d3",
	"./health-guide-healthy-habits.png": "0e68",
	"./health-guide-legs.png": "cfc1",
	"./health-guide-loads.png": "a735",
	"./health-guide-lungs.png": "619d",
	"./health-guide-noise.png": "67e9",
	"./health-guide-radiation.png": "85bc",
	"./health-guide-screen.png": "bf1e",
	"./health-guide-vaccination.png": "8170",
	"./health-kpis-bg.png": "69f2",
	"./health-monitoring-bg--disabled.png": "c695",
	"./health-monitoring-bg.png": "6780",
	"./health-telemedicina-bg--disabled.png": "a271",
	"./health-telemedicina-bg.png": "f76e",
	"./health-tpsalud-bg--disabled.png": "5c50",
	"./health-tpsalud-bg.png": "5ea7",
	"./ios-qr.png": "3125",
	"./logo-footer-ca.png": "bad3",
	"./logo-footer.png": "6331",
	"./logo-sngular.png": "26ae",
	"./logo-tps-azul.png": "eacc",
	"./logo-tps.png": "b521",
	"./logo-vitaly-yellow.png": "882e",
	"./logo-vitaly.png": "397a",
	"./no-matches.png": "f832",
	"./pdf-transparente.png": "427f",
	"./pexels-chevanon-photography-1108101 1.png": "0e95",
	"./preving-crm-logo.png": "6eb4",
	"./qr_google.png": "ac52",
	"./qr_tps.png": "ada3",
	"./technical-prevention-bg--disabled.png": "0e9c",
	"./technical-prevention-bg.png": "7670",
	"./telemedicina-icon.png": "40c4",
	"./telemedicina.png": "4b35",
	"./tps-app-sm.png": "9f85",
	"./tps-app.png": "8f57",
	"./tps-ecosystem-sm.png": "4866",
	"./tps-ecosystem.png": "a78c",
	"./tps-qr.png": "bb53",
	"./tpsalud-icon.png": "8a82",
	"./tpsalud.png": "7104",
	"./welcome-image.png": "05f1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a2";